import { setStoredDesktopBlockOrder, useDesktopBlockOrder } from '../utils/clientSettings';
import { DESKTOP_BLOCK_LABELS } from '../utils/desktopBlockOrder';
import { OrderControl } from './OrderControl';

export function DesktopBlockOrderControl() {
  const order = useDesktopBlockOrder();
  return <OrderControl title="Desktop block order" order={order} onChange={setStoredDesktopBlockOrder}
    label={block => DESKTOP_BLOCK_LABELS[block]} />;
}
